
import axios from 'axios';
import $ from 'jquery';
import React, { Component, useState } from 'react'
import "../../services/ApiRest";
import swal from 'sweetalert';
import { ApiUrl } from '../../services/ApiRest';
import { Alert } from 'bootstrap';
import ReactPaginate from 'react-paginate';
import Cookies from 'universal-cookie';
import "./hojasestilogestiontitulacion.css";
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';

const carrerasUrl = ApiUrl + "listarcarreras" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const baseUrlPeriodos = ApiUrl + "listperiodostodos" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaEstudTipoTitulacion = ApiUrl + "listestudtipotitula" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListarTiposTitulacion = ApiUrl + "listartipotitul" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlReportDocumentoTitulacionEst = ApiUrl + "documentitulaciontipotitulestud" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlRespuestaDocumentos = ApiUrl + "respuestadocumentrol" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const cookie = new Cookies();
const idRolAdministrativo = cookie.get("rol");

let listaauxiliar = [];
const itemsPerPage = 10;
export default class ListaEstudiantesTrabajoTitul extends Component {

    constructor(props) {
        super(props)

        this.state = {
            modalDescripcionDocumento: false,
            carrera: [],
            estud: [],
            EstudianteBackup: [],
            textBuscar: "",
            periodos: [],
            estado: "",
            idPeriodo: "1",
            idCarrera: "1",
            listtipotitulacion: [],
            documentoTitulacion: [],
            idEstudianteSelect: '',
            //variables para paginacion
            currentItems: null,
            pageCount: 0,
            itemOffset: 0,
            count: 0,
        }
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ estado: "" });
    }
    escFunction(event) {
        if (event.key === "Escape") {
            this.setState({ modalDescripcionDocumento: false });
        }
    }

    componentDidMount() {
        axios
            .get(baseUrlPeriodos, {})
            .then(response => {
                const listaperiodos = response.data.data;
                const cant = listaperiodos.length;
                if (cant != 0) {
                    this.setState({ periodos: listaperiodos });
                }
            })

        axios.get(carrerasUrl)
            .then(res => {
                const carrera = res.data;
                this.setState({ carrera });
            })

    }
    //BUSQUEDA......
    filter(event) {
        console.log(event.target.value);
        //obtener datos de buscar
        var text = event.target.value
        //obtener datos del array
        const data = this.state.estud
        var newData = data.filter(function (item) {
            //variable del objeto
            const itemDataPrimerApell = item.primer_apellido_estudiante.toUpperCase()
            const itemDataPrimerNom = item.primer_nombre_estudiante.toUpperCase()
            const itemDataCedula = item.numero_identificacion_estudiante.toUpperCase()
            const campo = itemDataPrimerApell + " " + itemDataPrimerNom + " " + itemDataCedula;   //variable del buscador
            const textData = text.toUpperCase()
            return campo.indexOf(textData) > -1
        })
        if (text == "") {
            newData = this.state.EstudianteBackup;
        }
        this.setState({
            currentItems: newData,
            textBuscar: text,
        })

    }


    handleChangeTipoTitulacionCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListarTiposTitulacion, {
                idCarreraTipoT: this.state.idCarrera
            })
            .then(response => {

                const listatipotitul = response.data.data;
                const cant = listatipotitul.length;
                if (cant != 0) {
                    this.setState({ listtipotitulacion: listatipotitul });
                }
                else {
                    this.setState({ error: "No existe tipos de titulación " });
                    swal({
                        text: "¡No existe tipos de titulación!",
                        icon: "info",
                        button: "Aceptar",
                    });

                }
            })
    }

    handleChangeEstudTipoTitulacion = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        axios
            .post(urlListaEstudTipoTitulacion, {
                idCarrera: this.state.idCarrera,
                idPeriodo: this.state.idPeriodo,
                idTipoTitulacion: this.state.idTipoTitulacion,
                idRolAdmin: idRolAdministrativo
            })
            .then(response => {
                if (response.data.success == true) {
                    listaauxiliar = response.data.data;
                    const estud = response.data.data;
                    this.setState((state) => {
                        return { estud: estud }
                    }
                    );
                    const EstudianteBackup = estud;
                    this.setState((state) => {
                        return { EstudianteBackup: EstudianteBackup }
                    });

                    //PAGINACION
                    this.setState({ itemOffset: 0 });
                    const endOffset = this.state.itemOffset + itemsPerPage;
                    this.setState({ currentItems: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ EstudianteBackup: listaauxiliar.slice(this.state.itemOffset, endOffset) });
                    this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
                    this.setState((state) => {
                        return { itemOffset: state.itemOffset + endOffset }
                    });
                    //FIN  DE LA PAGINACION
                    this.setState({ estado: "" });

                } else {
                    const estudiantes = [];
                    this.setState({ estudiantes });
                    this.setState({ estado: "No existe datos para mostrar" });
                    swal({
                        text: "No existe datos para mostrar",
                        icon: "info",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                const estudiantes = [];
                this.setState({ estudiantes });
                this.setState({ estado: "No existe conexión con el servidor" });
                swal({
                    text: "No existe conexión con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }

    //FUNCION DE PAGINACION POR  MEDIO DE UN CLIC
    handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % listaauxiliar.length;
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
        const endOffset = newOffset + itemsPerPage;
        this.setState({ currentItems: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ EstudianteBackup: listaauxiliar.slice(newOffset, endOffset) });
        this.setState({ pageCount: Math.ceil(listaauxiliar.length / itemsPerPage) });
        this.setState((state) => {
            return { itemOffset: newOffset }
        });
    }
    seleccionarEstudianteuno = async (e, consola) => {
        await this.setState({ [e.target.name]: e.target.value })
        this.setState({ idEstudianteSelect: consola.id_estudiante });
        this.setState({ documentoTitulacion: [] });

        // Actualizar la lista de documentos de los estudiantes
        axios.post(urlReportDocumentoTitulacionEst, {
            idTipoTitul: this.state.idTipoTitulacion,
            idEstudiante: consola.id_estudiante,
            idCarrera: this.state.idCarrera,
        })
            .then(res => {
                const documentoTitulacion = res.data.data;
                this.setState({ documentoTitulacion });
            })
    }

    //Modificar información del documento
    modificarInformacionDocumento = (e, consola) => {
        var idSelectEstadoDoc = "estdocumentitul" + this.state.idEstudianteSelect + "" + consola.id_documento_titulacion;
        var idEstado = document.getElementById(idSelectEstadoDoc).value;
        var idObservcionDoc = "obsdocumentitul" + this.state.idEstudianteSelect + "" + consola.id_documento_titulacion;
        var observacion = document.getElementById(idObservcionDoc).value;
        var idInputFile = "filedocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion;
        var inputFile = document.getElementById(idInputFile);
        var archivo = inputFile?.files[0]; // solo el primer archivo
        var archivoselect = archivo;
        if (archivo) {
            // Validación de tipo de archivo
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(archivo.type)) {
                swal({
                    text: "El archivo debe ser de tipo PDF o Word (.doc, .docx)",
                    icon: "error",
                    button: "Aceptar",
                });
                return; // Detenemos la ejecución si el archivo no es válido
            }
            //Tomar el valor del select
        } else {
            archivoselect = null;
        }

        var idDocumentoEstud = consola.iddocumentestud;

        const formData = new FormData();
        formData.append("idestadodocument", idEstado);
        formData.append("observaciondoc", observacion);
        formData.append("archivorevisado", archivoselect);
        formData.append("iddocumentoestudiante", idDocumentoEstud);
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        // Enviar la solicitud POST con el archivo
        axios.post(urlRespuestaDocumentos, formData, config)
            .then(response => {
                if (response.data.success) {
                    swal({
                        text: "Información actualizada correctamente",
                        icon: "success",
                        button: "Aceptar",
                    });
                    // Actualizar la lista de documentos de los estudiantes
                    axios.post(urlReportDocumentoTitulacionEst, {
                        idTipoTitul: this.state.idTipoTitulacion,
                        idEstudiante: this.state.idEstudianteSelect,
                        idCarrera: this.state.idCarrera,
                    })
                        .then(res => {
                            const documentoTitulacion = res.data.data;
                            this.setState({ documentoTitulacion });
                        })
                } else {
                    swal({
                        text: response.data.message || "Error al cargar el documento",
                        icon: "error",
                        button: "Aceptar",
                    });
                }
            })
            .catch(error => {
                console.error("Error en la solicitud:", error);
                swal({
                    text: "No se pudo conectar con el servidor",
                    icon: "error",
                    button: "Aceptar",
                });
            });
    }
    mostrarModalDescripDocumento = (registro) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: registro || ''
        });
    };
    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    }

    render() {
        return (
            <div className="row animate__animated animate__fadeIn">
                <div className="card p-3 mb-2 bg-white rounded-4 shadow-sm border-0">
                    <div className="back-istmas">
                        <i className="fas fa-graduation-cap bounce-custom fs-5"></i>
                        <b className="mb-0 fw-semibold"> Estudiantes asignados para el desarrollo del Trabajo de Titulación</b>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-12 col-md-6 col-xl-3">
                                <label className="form-label"><b> <i className="fa-magnifying-glass"></i> Buscar:</b></label>

                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    value={this.state.text}
                                    placeholder="Buscar..."
                                    onChange={(text) => this.filter(text)}
                                />
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">
                                <label className="form-label"><b> <i className="fa fa-calendar"></i> Período</b></label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idPeriodo"
                                    value={this.state.value}
                                    onChange={this.handleChange}
                                >
                                    <option value="undefined" selected disabled>Seleccione el período</option>
                                    {this.state.periodos.map(periodo => (
                                        <option key={periodo.id_periodo_academico} value={periodo.id_periodo_academico}>
                                            {periodo.descripcion_periodo_academico}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">
                                <label className="form-label"><b>Carrera</b></label>
                                <select
                                    className="form-select form-select-sm"
                                    id="idCarrera"
                                    name="idCarrera"
                                    value={this.state.value}
                                    onChange={this.handleChangeTipoTitulacionCarrera}
                                >
                                    <option value="undefined" selected disabled>Seleccione una carrera</option>
                                    {this.state.carrera.map(person => (
                                        <option key={person.id_carrera} value={person.id_carrera}>
                                            {person.descripcion_carrera}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">

                                <label className="form-label"><b>Tipos titulación</b></label>
                                <select
                                    className="form-select form-select-sm"
                                    name="idTipoTitulacion"
                                    value={this.state.value}
                                    onChange={this.handleChangeEstudTipoTitulacion}
                                >
                                    <option value="undefined" selected disabled>Seleccione un tipo de titulación</option>
                                    {this.state.listtipotitulacion.map(person => (
                                        <option key={person.id_tipo_titulacion} value={person.id_tipo_titulacion}>
                                            {person.nom_tipo_titulacion}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-12 col-sm-12 col-lg-1 col-xl-3">
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <div className="card border-0 shadow-sm">
                                    <h6 className="fw-bold text-center mb-3 text-azul">
                                        Estudiantes
                                    </h6>
                                    <div className="table-responsive">
                                        <table className="table table-sm-custom table-hover align-middle">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="text-start text-azul">Cédula</th>
                                                    <th className="text-start text-azul">Primer Apellido</th>
                                                    <th className="text-start text-azul">Segundo Apellido</th>
                                                    <th className="text-start text-azul">Primer Nombre</th>
                                                    <th className="text-start text-azul">Segundo Nombre</th>
                                                    <th className="text-center text-azul">Estado</th>
                                                    <th className="text-center text-azul">Seleccionar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.currentItems &&
                                                    this.state.currentItems.map((consola) => (
                                                        <tr key={consola.id_estudiante}>
                                                            <td className="text-start text-azul">{consola.numero_identificacion_estudiante}</td>
                                                            <td className="text-start text-azul">{consola.primer_apellido_estudiante}</td>
                                                            <td className="text-start text-azul">{consola.segundo_apellido_estudiante}</td>
                                                            <td className="text-start text-azul">{consola.primer_nombre_estudiante}</td>
                                                            <td className="text-start text-azul">{consola.segundo_nombre_estudiante}</td>
                                                            <td className="text-center">
                                                                {consola.estado_general === 1 && (
                                                                    <span className="badge bg-success text-white small rounded-pill">Procesar</span>
                                                                )}
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    type="radio"
                                                                    value="1"
                                                                    name="interfazdocument"
                                                                    onChange={(e) => this.seleccionarEstudianteuno(e, consola)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-flex justify-content-center mt-3">
                                        <ReactPaginate
                                            previousLabel="<"
                                            nextLabel=">"
                                            pageCount={this.state.pageCount}
                                            onPageChange={this.handlePageClick}
                                            containerClassName="pagination pagination-sm-custom"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* tabla de reporte de documentos estudiante */}
                        <br />

                        <div className="p-3 rounded-3 mt-3" hidden={this.state.disableForm4} >
                            <h6 className="fw-bold text-center mb-3 text-azul">Estado de documentos</h6>

                            <div className="table-responsive">
                                <table className="table table-hover table-sm-custom">
                                    <thead className="table-light">
                                        <tr className="text-start text-azul" >
                                            <th className="d-none">ID</th>
                                            <th className="text-start text-azul">No</th>
                                            <th className="text-start text-azul">Nombre</th>
                                            <th className="text-start text-azul">Descripción</th>
                                            <th className="text-start text-azul">Formato</th>
                                            <th className="text-start text-azul">Archivo subido</th>
                                            <th className="text-start text-azul">Fecha de envío</th>
                                            <th className="d-none">CarreraTipoTitulacion</th>
                                            <th className="text-start text-azul">Revisado por</th>
                                            <th className="text-start text-azul">Observaciones</th>
                                            <th className="text-start text-azul">Cargar Archivo</th>
                                            <th className="text-start text-azul">Estado</th>
                                            <th className="text-start text-azul">Responder</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.documentoTitulacion.map((consola) => (
                                            <tr className="text-start text-azul" key={consola.id_documento_titulacion}>
                                                <td className="d-none">{consola.id_documento_titulacion}</td>
                                                <td>{consola.orden_documento_id}</td>
                                                <td>{consola.nom_documento_titulacion}</td>
                                                <td> <button
                                                    onClick={() => this.mostrarModalDescripDocumento(consola.descrip_documento_titulacion)}
                                                    style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
                                                >
                                                    <i className="fa fa-2x fa-align-left text-primary" ></i>
                                                </button>

                                                </td>
                                                <td>
                                                    {consola.archivo_documento_titulacion && (
                                                        <a href={consola.ruta_formato} target="_blank" rel="noopener noreferrer">
                                                            <i class="fa fa-2x fa-file-alt text-danger" title="Descargar el formato" aria-hidden="true"></i>
                                                        </a>
                                                    )}
                                                </td>
                                                <td>
                                                    {consola.iddocumentestud === 0 ? (
                                                        <span className="small text-muted">Aún no se ha subido ningún archivo.</span>
                                                    ) : (
                                                        consola.archivo_documento_titulacion && (
                                                            <a href={consola.ruta_document_cargado} target="_blank" rel="noopener noreferrer" title="Descargar el archivo subido">
                                                                <i class="fa fa-2x fa-file-alt text-success" aria-hidden="true"></i>
                                                            </a>
                                                        )
                                                    )}
                                                </td>
                                                <td>{consola.fecha_envio}</td>
                                                <td className="d-none">{consola.carrera_tipo_titulacion_id}</td>
                                                <td>{consola.descripcion_rol}</td>
                                                <td>
                                                    <textarea
                                                        name={`obsdocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        id={`obsdocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        onChange={this.handleChange}
                                                        className="form-control form-control-sm"
                                                        placeholder=""
                                                        maxLength="500"
                                                        required
                                                        disabled={this.state.isDisabled}
                                                    >
                                                        {consola.observacion_documento}
                                                    </textarea>
                                                </td>
                                                <td>
                                                    <input
                                                        type="file"
                                                        accept=".pdf,.doc,.docx"
                                                        id={`filedocumentitul${this.state.idEstudianteSelect}${consola.id_documento_titulacion}`}
                                                        className="form-control form-control-sm"
                                                    />
                                                </td>
                                                <td>
                                                    <select className="form-select" name={"estdocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion} id={"estdocumentitul" + this.state.idEstudianteSelect + consola.id_documento_titulacion} value={this.state.value} aria-label="Default select example">
                                                        <option value="undefined" selected="true" disabled>Seleccione el estado</option>
                                                        {consola.lista_estad_rol.map(estados => <option key={estados.id_estad_documentos_titulacion} value={estados.id_estad_documentos_titulacion} > {estados.nom_estad_documentos_titulacion}</option>)}

                                                    </select>

                                                    {(() => {
                                                        if (consola.id_estado > 0) {
                                                            var nom = this.state.idEstudianteSelect;
                                                            $(function () {
                                                                var nombrevar = nom + "" + consola.id_documento_titulacion;
                                                                $("#estdocumentitul" + nombrevar).val(consola.id_estado);
                                                            });
                                                        } else {
                                                            var nom = this.state.idEstudianteSelect;
                                                            $(function () {
                                                                var nombrevar = nom + "" + consola.id_documento_titulacion;
                                                                $("#estdocumentitul" + nombrevar).prop('selectedIndex', 0); // o .val('') si usas un value vacío
                                                            });
                                                        }

                                                    })()}








                                                </td>
                                                <td>
                                                    {consola.iddocumentestud === 0 ? (
                                                        <span className="small text-muted">Pendiente</span>
                                                    ) : ((consola.id_estado === 1 || consola.id_estado === 3) && consola.id_rol === idRolAdministrativo && (
                                                        <button
                                                            onClick={(e) => this.modificarInformacionDocumento(e, consola)}
                                                            className={`btn btn-sm ${consola.id_estado === 1 ? 'btn-success' : 'btn-secondary'} rounded-pill`}
                                                        >
                                                            <i className="fas fa-clipboard-check"></i>
                                                        </button>
                                                    ))}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <Modal isOpen={this.state.modalDescripcionDocumento}>
                            <ModalHeader>
                                <h5>Descripción</h5>
                            </ModalHeader>
                            <ModalBody>
                                <div className="mb-3 centrar">
                                    <p className="texto-justificado">{this.state.descripcionDocumento}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <button className="btn btn-outline-primary" onClick={this.ocultarModalDescripDocumento}>
                                    Salir
                                </button>
                            </ModalFooter>
                        </Modal>
                        {/* fIN DE ESCONDIDOS */}
                        <br />
                        <div className="alert alert-warning" role="alert" hidden={this.state.hidden}>
                            {this.state.estado}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
